import React from "react";
import "../components/UploadDocuments/upload.css";
import upload from "../images/upload.ico";
import checkIcn from "../images/ok.ico";

const UploadInput = ({
  label,
  name,
  onClick,
  onChange,
  type,
  value,
  documentUploaded,
  uploadErrmsg,
  uploadSuccmsg,
  index,
}) => {
  // function closeError() {
  //   uploadErrmsg == undefined;
  //   // this.setState({
  //   //   verificationError: true,
  //   //   errMsg: "Please check you network connection",
  //   // });
  // }

  return (
    <>
      <div className="input-group">
        <div className="leftInputG">
          <p>{label}</p>
          <p className="doc-type-msg">{`( Document should be in ${type} and less than 5MB )`}</p>
        </div>
        <div className="rightButton">
          <label htmlFor={name}>
            <img className="upld-icn" src={upload} alt="" />
            <span style={{ margin: "0 5px" }}>Upload</span>
            {documentUploaded === true ? (
              <img className="chk-icn" src={checkIcn} alt="" />
            ) : null}
          </label>
          <input
            id={name}
            onChange={onChange}
            onClick={() => onClick(index)}
            type="file"
            defaultValue={value}
            accept={type}
            name={name}
          />
        </div>
        {uploadErrmsg ? (
          <div className="size-limit-msg err-msg">{uploadErrmsg}</div>
        ) : (
          <div className="size-limit-msg-succ">{uploadSuccmsg}</div>
        )}
      </div>
    </>
  );
};

export default UploadInput;
